export enum EnumTypeMail {
    BL = 0,
    BUSINESS = 1,
    BILLING = 2,
}
